/**
 * Filters a small, explicit allow-list of known-benign third-party console
 * warnings that we cannot fix from application code.
 *
 * Currently suppresses ONE message: the Vue Router `next()` deprecation that is
 * emitted by `@sentry/vue`'s router instrumentation (`instrumentVueRouter`),
 * which still calls `next()` for Vue Router 2/3 compatibility while
 * `vue-router@5` deprecates it. Our own navigation guards already use the
 * return-style API, so dropping this exact message does not hide real issues.
 *
 * The filter is intentionally narrow (exact substring match) and idempotent so
 * all other warnings continue to surface normally.
 */
const SUPPRESSED_WARNING_FRAGMENTS: readonly string[] = [
    'The `next()` callback in navigation guards is deprecated',
];

let installed = false;

export function suppressKnownWarnings(): void {
    if (installed) {
        return;
    }
    installed = true;

    const originalWarn = console.warn.bind(console);

    console.warn = (...args: unknown[]): void => {
        const first = args[0];
        if (typeof first === 'string' && SUPPRESSED_WARNING_FRAGMENTS.some((fragment) => first.includes(fragment))) {
            return;
        }
        originalWarn(...args);
    };
}
